import { IS_CSR } from '@constants/ssr';

export function splitBy<T>(list: T[], callback: (currentItem: T) => boolean): T[][] {
  const splitList: T[][] = [];
  let currentSubList: T[] = [];

  list.forEach((element, index) => {
    if (callback(element)) {
      if (index !== 0) splitList.push(currentSubList);
      currentSubList = [element];
    } else {
      currentSubList.push(element);
    }
  });

  splitList.push(currentSubList);

  return splitList;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (): void => { };

export const canUseSpread = (value: unknown): boolean => {
  if (!value || typeof value === 'function' || typeof value !== 'object') return false;
  return true;
};

export const getLocationHash = (): string | null => (IS_CSR ? decodeURIComponent(window.location.hash) : null);

export const scrollElementToCenterX = (element: HTMLElement): void => {
  const child = element;
  const parent = element.parentElement;

  if (!parent) {
    // Only true for the root element
    return;
  }

  const childBBox = child.getClientRects().item(0);
  const parentBBox = parent.getClientRects().item(0);

  if (!childBBox || !parentBBox) {
    return;
  }

  const childLeftPosition = childBBox.left;
  const halfChildWidth = childBBox.width / 2;
  const currentParentScroll = parent.scrollLeft;
  const halfParentWidth = parentBBox.width / 2;

  const newLeftScroll = childLeftPosition + currentParentScroll - halfChildWidth - halfParentWidth;

  parent.scrollTo({ left: newLeftScroll, behavior: 'smooth' });
};

export const wait = (time: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, time));
